/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Communication, Logger } = Utils;

const SendPreviewEmailModal = ({ data: { emailAddress, emailInfo }, modalId }) => {
	const { showError, closeModal } = useContext(ModalContext);

	const onSendButtonClick = async () => {
		const emailParams = {
			subject: emailInfo.Subject,
			body: emailInfo.MessageBody,
			footer: emailInfo.PromotionalFooter,
			orderDetails: emailInfo.IncludeOrderDetail,
			customizedFrom: emailInfo.SenderName,
		};

		Logger.saveActionData('Send Preview Email Button Clicked');

		const response = await Communication.testShipNotificationEmail(emailParams);

		if (Communication.isSuccessful(response)) {
			// per WEBAPPS-25924, improving Emails logging
			Logger.logToServer({
				category: 'Send Preview',
			});

			closeModal(modalId);
		} else {
			showError({ response });
		}
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Send Preview Email',
		onClick: onSendButtonClick,
		dataqa: 'send-preview-email-send-preview-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="account-email-container preview-modal"
			header="Send Preview Email"
			primaryButton={primaryButton}
		>
			<div className="body">
				<p>We will send a preview Tracking Email to the address specified below.</p>
				<div className="email-address">
					<p>Your Email: {emailAddress}</p>
				</div>
			</div>
		</Modal>
	);
};

export default SendPreviewEmailModal;
